var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode } from './content-node';
import { IconLabelLink } from '../elements/icon-label-link';
import { useSite } from '../hooks/use-site';
import { OrganisationMarketMapGrid } from './organisation-market-map-grid';
import { usePageEntity } from '../hooks/use-page-entity';
var cls = classNames('market-map-panel');
export var MarketMapPanelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 300;\n  "], ["\n    color: ", ";\n    font-weight: 300;\n  "])), theme.COLOR('text'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-self: stretch;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-self: stretch;\n    width: 100%;\n  "])), theme.UNIT(6))
});
var OrganisationsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
var OrgCarouselStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkButtonContainerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-end;\n    \n  "], ["\n    display: flex;\n    justify-content: flex-end;\n    \n  "])))
});
var LinkButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n   \n  "], ["\n\n   \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Description: styled(ContentNode)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Body: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Organisations: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), OrganisationsStyles),
  OrganisationCards: styled(OrganisationMarketMapGrid)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), OrgCarouselStyles),
  LinkButtonContainer: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonContainerStyles),
  LinkButton: styled(IconLabelLink)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles)
};
export var MarketMapPanel = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var site = useSite();
  var activeEntity = usePageEntity();
  var _b = entity.organisations,
    organisations = _b === void 0 ? [] : _b,
    description = entity.description;
  var hasDescription = !!(description === null || description === void 0 ? void 0 : description.text);
  var hasOrganisations = !!organisations.length;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasOrganisations && React.createElement(My.Body, null, React.createElement(My.LinkButtonContainer, null, React.createElement(My.LinkButton, {
    href: "".concat((_a = site === null || site === void 0 ? void 0 : site.explorerPage) === null || _a === void 0 ? void 0 : _a.path, "#view=market-map&countries=").concat(activeEntity.slug),
    label: 'View Innovators by Country'
  })), React.createElement(My.OrganisationCards, {
    items: organisations.slice(0, 5),
    spacing: 2,
    hasBorder: true
  })), children);
};
MarketMapPanel.defaultProps = MarketMapPanelDefaultProps;
MarketMapPanel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;